import { jsx as _jsx } from 'react/jsx-runtime.js';
import { Alert } from '@stepstone-genesis/components';
import { useTranslation } from '@stepstone-platform/i18n';
import { useAppSelector } from '../../../../hooks/redux/index.js';
import { authErrorSelector } from '../../../../core/authError/authErrorSlice.js';
export const LoginAlert = () => {
    const { t } = useTranslation();
    const { source, message } = useAppSelector(authErrorSelector);
    if (!source) {
        return null;
    }
    const errorMessage = message ?? t(`loginregistration.twoStepLoginRegistration.alert.${source}`);
    return (_jsx(Alert, { variant: 'negative', mb: 'spaceL', isDismissible: false, children: errorMessage }));
};
//# sourceMappingURL=LoginAlert.js.map